import { useQuery } from '@tanstack/react-query';
import { adminClient } from '@/lib/adminClient';

export const conversationKeys = {
  all: ['conversations'] as const,
  list: (query: string, pageSize: number, pageToken: string) =>
    [...conversationKeys.all, 'list', query, pageSize, pageToken] as const,
  detail: (id: string) => [...conversationKeys.all, 'detail', id] as const,
};

export function useConversations(query = '', pageSize = 25, pageToken = '') {
  return useQuery({
    queryKey: conversationKeys.list(query, pageSize, pageToken),
    queryFn: () =>
      adminClient.listConversations({ query: query || undefined, pageSize, pageToken: pageToken || undefined }),
  });
}

export function useConversationDetail(conversationId: string) {
  return useQuery({
    queryKey: conversationKeys.detail(conversationId),
    queryFn: () => adminClient.getConversation(conversationId),
    enabled: !!conversationId,
  });
}
